<script setup>
const props = defineProps(['data'])
const emits = defineEmits(['onChange'])
console.log(props.data)

function toggle(item) {
  item.isSelected = !item.isSelected;
}

</script>
<template>
  <div class="container">
    <div class="left">
      <p>Assigned Physicians:</p>
    </div>
    <div class="right">
      <div class="item-container">
        <div v-for="(item) in props.data" :key="item" @click="toggle(item)">
          <p :class="{ selected: item.isSelected, item: true }">{{ item.name }}</p>
        </div>
      </div>

    </div>
  </div>
</template>
<style scoped lang="scss">
@import "@/styles/registration.scss";

.selected {
  background-color: #c415ff64;
  border: 1px solid #bf00ff;
  border-radius: 1rem;
}

p {
  padding: 0;
  margin: 0;
}

.item-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end; // fucking god send

}

.item {
  text-align: center;
  padding: 0;
  margin: 0.25rem 0;
  width: 18rem;

}
</style>